const OutcomeLabelMatch = {
    title: 'Example JSON',
    expectedOutput: 'EventHomeName or Draw',
    initialDisplayedCode: `{
    "outcomeId": 2950948551,
    "betOffer": {
      "id": 883929922,
      "betOfferType": {
        "id": 2,`,
    moreCode: `
        "name": "betOffer name"
      },
      "place": false,
      "outcomes": [
        {
          "id": 2950948551,
          "label": "Arsenal",
          "type": "OT_ONE_CROSS"
        },
        {
          "id": 2950948554,
          "label": "Feyenoord",
          "type": "OT_ONE_TWO"
        }
      ]
    },
    "event": {
      "awayName": "EventAwayName",
      "homeName": "EventHomeName"
    }
  }`,
};

export default OutcomeLabelMatch;
